import { useEffect, useState } from 'react'
import Logo from '../../../Assets/Images/DashboardMigrants/direccion-de-atencion-a-personas-migrantes-logo.png'
import { Link, useHistory, useLocation } from 'react-router-dom'
import { toastSweetAlert } from '../../Helpers/ToastSweetAlert'
import {
  useApolloClient,
  useMutation,
  useQuery,
  useSubscription,
} from '@apollo/client'
import withReactContent from 'sweetalert2-react-content'
import Swal from 'sweetalert2'
import { types } from '../../../Types/types'
import { EMPTY } from '../../../graphql/Auth/auth'
import MigrantsSideBarRight from './MigrantsSideBarRight'
import {
  COUNT_MIGRANTS_NOTIFICATIONS,
  MIGRANTS_NOTIFICATION_ADDED,
  USER_MIGRANTS_NOTIFICATIONS,
} from '../../../graphql/Catalog/Migrants/migrantsNotifications'
import {
  GET_MIGRANTS_INTERNAL_NOTES,
  NOTIFY_MIGRANTS_INTERNAL_NOTES_SUBSCRIPTION,
} from '../../../graphql/Catalog/Migrants/migrantsInternalNotes'
import { limitMaxNotification } from './MigrantsNotifications'

const MigrantsHeader = ({
  user,
  dispatch,
  setView = () => {},
  showContact = true,
}) => {
  //------------ Hooks ------------
  const history = useHistory()
  const [dropdownOpen, setDropdownOpen] = useState(false)
  const client = useApolloClient()
  const MySwal = withReactContent(Swal)
  const location = useLocation()
  const [count, setCount] = useState(null)

  //Control Sidebar Right
  const [showSidebarRight, setShowSidebarRight] = useState(false)
  const [typeSidebarRight, setTypeSidebarRight] = useState(null)

  // ------------- Queries and Mutations -------------
  const [emptyMutation] = useMutation(EMPTY)
  const { data, loading, error } = useQuery(COUNT_MIGRANTS_NOTIFICATIONS)

  useSubscription(MIGRANTS_NOTIFICATION_ADDED, {
    onData: async ({ data }) => {
      const dataResp = data?.data?.migrantsNotificationAdd
      if (dataResp.some((item) => item?.id_user === user?.idUser)) {
        await emptyMutation({
          variables: {},
          refetchQueries: [
            { query: COUNT_MIGRANTS_NOTIFICATIONS },
            {
              query: USER_MIGRANTS_NOTIFICATIONS,
              variables: {
                limit: limitMaxNotification,
                offset: 0,
              },
            },
          ],
        })
      }
    },
  })

  useSubscription(NOTIFY_MIGRANTS_INTERNAL_NOTES_SUBSCRIPTION, {
    onData: async ({ data }) => {
      const dataResp = data?.data?.notifyMigrantsInternalNotesSuscription
      if (dataResp?.document_id) {
        await emptyMutation({
          variables: {},
          refetchQueries: [
            {
              query: GET_MIGRANTS_INTERNAL_NOTES,
              variables: {
                document_id: dataResp?.document_id,
              },
              fetchPolicy: 'no-cache',
            },
          ],
        })
      }
    },
  })

  // ------------- UseEffect -------------
  useEffect(() => {
    if (!loading) {
      if (error) setCount(null)
      setCount(!data?.count ? null : data?.count)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loading, error, data])

  useEffect(() => {
    if (dropdownOpen) {
      document.addEventListener('mousedown', handleClickOutside)
    } else {
      document.removeEventListener('mousedown', handleClickOutside)
    }
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [dropdownOpen])

  //Functions
  const handleDropdownToggle = () => {
    setDropdownOpen((prev) => !prev)
  }

  const handleClickOutside = (event) => {
    if (!event.target.closest('.dropdown')) {
      setDropdownOpen(false)
    }
  }

  const toggleSidebarRight = () => {
    setShowSidebarRight(!showSidebarRight)
  }

  const handleLogout = () => {
    MySwal.fire({
      icon: 'info',
      showCloseButton: true,
      showDenyButton: true,
      reverseButtons: true,
      title: 'Cerrar sesión',
      html: (
        <div className="message-container">¿Estás seguro de cerrar sesión?</div>
      ),
      allowOutsideClick: false,
      buttonsStyling: false,
      confirmButtonText: 'Cerrar sesión',
      denyButtonText: 'Cancelar',
      focusDeny: true,
      customClass: {
        title: 'StandarModalTitle',
        htmlContainer: 'StandarModalHtmlContainer',
        confirmButton: 'btn btn-migrates',
        denyButton: 'btn btn-migrates-white',
        footer: 'btn StandarModalFooterLogOut',
      },
    }).then((result) => {
      if (result.isConfirmed) {
        try {
          client.clearStore()
          sessionStorage.removeItem('user')
          sessionStorage.removeItem('requestPath')
          localStorage.removeItem('token')
          localStorage.removeItem('configSys')
          localStorage.removeItem('platform')
          toastSweetAlert({
            mode: 'ok',
            message: 'Cerrar sesión con éxito',
          })
          setTimeout(() => {
            dispatch({
              type: types.logout,
            })
          }, 400)
        } catch (error) {
          toastSweetAlert({
            mode: 'error',
            message: error.message,
          })
        }
      }
    })
  }

  const handleClickNotification = () => {
    toggleSidebarRight()
    setTypeSidebarRight('Notifications')
  }

  return (
    <header className="migrants-header">
      <div className="header-content">
        <img
          onClick={() => {
            if (location.pathname !== '/dashboardMigrants')
              history.push('/dashboardMigrants')
            else setView(1)
          }}
          src={Logo}
          alt="migrants-logo"
          className="logo"
        />
      </div>
      <div className="header-actions">
        {showSidebarRight && (
          <MigrantsSideBarRight
            setType={setTypeSidebarRight}
            type={typeSidebarRight}
            toggleSidebar={toggleSidebarRight}
          />
        )}
        <ul>
          {user?.role === 16 && (
            <li>
              <Link to={'/dashboardMigrants/logged'}>Trámites</Link>
            </li>
          )}
          {showContact && (
            <li>
              <Link to={'/dashboardMigrants/contact'}>Contacto</Link>
            </li>
          )}
          {user?.logged && (
            <>
              <li>|</li>
              <li>
                <div className="dropdown">
                  <div
                    className="dropdown-toggle"
                    onClick={handleDropdownToggle}
                    tabIndex={0}
                    role="button"
                    aria-haspopup="true"
                    aria-expanded={dropdownOpen}
                  >
                    <i className="fas fa-user" />{' '}
                    <span>
                      {user?.name} #{String(user?.idUser).padStart(2, '0')}
                    </span>
                  </div>
                  <ul
                    className="dropdown-menu"
                    style={{ display: dropdownOpen ? 'block' : 'none' }}
                  >
                    {user?.role !== 16 && (
                      <li>
                        <Link
                          to={'/dashboard'}
                          onClick={() => setDropdownOpen(false)}
                        >
                          Portal
                        </Link>
                      </li>
                    )}
                    <li>
                      {user?.role === 16 && (
                        <>
                          <div>
                            <Link
                              to={{
                                pathname:
                                  '/dashboardMigrants/logged/user/profile',
                                state: { initialTab: 'profile' },
                              }}
                            >
                              <span>Datos de perfil</span>
                            </Link>
                          </div>
                          <Link
                            to={{
                              pathname:
                                '/dashboardMigrants/logged/user/history',
                              state: { initialTab: 'history' },
                            }}
                          >
                            <span>Historial de trámites</span>
                          </Link>
                        </>
                      )}
                      <div
                        onClick={() => {
                          handleLogout()
                          setDropdownOpen(false)
                        }}
                      >
                        <span>Cerrar sesión</span>
                      </div>
                    </li>
                  </ul>
                </div>
              </li>
              <li
                className="notification-option dropdown mr-2"
                style={{ width: '30px', cursor: 'pointer' }}
                onClick={() => handleClickNotification()}
              >
                <span className="nav-link">
                  <i className="far fa-bell" style={{ fontSize: '23px' }} />
                  {count && (
                    <span
                      className="badge badge-warning navbar-badge"
                      style={{ top: '16px', right: '8px' }}
                    >
                      {count}
                    </span>
                  )}
                </span>
              </li>
            </>
          )}
        </ul>
      </div>
    </header>
  )
}

export default MigrantsHeader
